import React, { useState } from "react";
import { toast } from "react-toastify";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

//import FotoCanaa from '../../assets/cidade_canaa.jpg';
import api from "../../services/api";
import { login } from "../../services/auth";
import "./styles.css";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/conecta-banner.png)`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(0, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn() {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);


  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);
    try {
      //
      let lowerEmail = email.toLowerCase();
      // Requisição do formulário de login
      const response = await api.post("/login", {
        email: lowerEmail,
        password: senha,
      });
      // Recure o token do login realizado pelo usuário
      login(response.data.token);

      // Verifica a role do usuário. Somente irão logar Controlador, Executor ou Admin
      const res = await api.get(`/profile`);
      const roleUser = res.data.permission;

      if (
        roleUser === "Controlador" ||
        roleUser === "Executor" ||
        roleUser === "Admin"
      ) {
        // Salva informações no localstorage para ser usadas no restante do código
        localStorage.setItem("NameUser", res.data.name);
        localStorage.setItem("IdUser", res.data.id);
        localStorage.setItem("Permission", res.data.permission);

        // Redireciona para a página de search
        window.location.href = "/search";
      } else {
        // Caso o usuário não pertença a nenhuma das roles especificadas a página sofre um refresh.
        toast.error("Houve um problema com o login, verifique suas credenciais!");
        // window.location.reload();
      }
    } catch (err) {
      console.log(err);
      toast.error("Houve um problema com o login, verifique suas credenciais!");
      // window.location.reload();
    } finally {
      setLoading(false);
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className="login-container">
          <CssBaseline />

          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>

            <Typography component="h1" variant="h5">
              Login
            </Typography>

            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Digite seu e-mail"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Digite sua senha"
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />

              <div className="logar">
                <button type="submit" className="button" disabled={loading}>
                  {loading ? "Entrando..." : "Entrar"}
                </button>
              </div>

              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Link style={{ cursor: "pointer" }} href="/forget-password">
                    Esqueci minha senha
                  </Link>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item style={{ textAlign: "left", marginTop: "10px" }}>
                  <p>
                    Problemas para realizar login? Entre em contato com o
                    administrador do sistema através do e-mail{" "}
                    <b>projetocanaaufpa@gmail.com</b>.
                  </p>
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
